<template>
  <v-dialog persistent v-model="isToggleDialogCampaign" width="800">
    <v-toolbar color="gray">
      <v-toolbar-title>
        <h1>{{ setTitleFrms }}</h1>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn @click="disableDialog" icon>
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <div>
      <v-card>
        <v-card-text>
          <div style="padding: 10px">
            <v-form ref="form" v-model="valid">
              <v-text-field
                label="ชื่อแคมเปญ (TH)"
                v-model="baseForm.dm_name_th"
                :rules="[rules.required]"
                prepend-icon="title"
              ></v-text-field>
              <v-text-field
                label="ชื่อแคมเปญ (ENG)"
                v-model="baseForm.dm_name_en"
                :rules="[rules.required]"
                prepend-icon="title"
              ></v-text-field>
              <v-text-field
                label="ชื่อแคมเปญ (CN)"
                prepend-icon="title"
                v-model="baseForm.dm_name_cn"
                :rules="[rules.required]"
              ></v-text-field>
              <v-text-field
                label="ระยะทางเริ่มต้น"
                type="number"
                prepend-icon="place"
                v-model="baseForm.dm_start"
                :rules="[rules.required]"
              ></v-text-field>
              <v-text-field
                label="ระยะทางปลายทาง"
                type="number"
                prepend-icon="pin_drop"
                v-model="baseForm.dm_end"
                :rules="[rules.required]"
              ></v-text-field>

              <v-text-field
                label="ส่วนลด (หน่วย:บาท)"
                type="number"
                prepend-icon="money_off"
                v-model="baseForm.dm_price"
                :rules="[rules.required]"
              ></v-text-field>
              <v-text-field
                label="ราคาขั้นต่ำ (หน่วย:บาท)"
                type="number"
                prepend-icon="attach_money"
                v-model="baseForm.dm_minimum"
                :rules="[rules.required]"
              ></v-text-field>
              <v-layout>
                <v-flex xs6 class="pr-2">
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="baseForm.datestart"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="baseForm.datestart"
                        :rules="[rules.required]"
                        label="วัน/เวลา เริ่มต้น"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      @input="
                        $refs.menu.save(baseForm.datestart);
                        menu = false;
                      "
                      v-model="baseForm.datestart"
                      no-title
                      scrollable
                    >
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs6>
                  <vue-timepicker
                    style="width: 100%"
                    v-model="baseForm.timestart"
                    class="custom-timepicker"
                    format="HH:mm"
                  />
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs6 class="pr-2">
                  <v-menu
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="baseForm.dateend"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="baseForm.dateend"
                        :rules="[rules.required]"
                        label="วัน/เวลา สิ้นสุด"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="baseForm.dateend"
                      no-title
                      scrollable
                      @input="
                        $refs.menu2.save(baseForm.dateend);
                        menu2 = false;
                      "
                    >
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs6>
                  <vue-timepicker
                    style="width: 100%"
                    v-model="baseForm.timeend"
                    class="custom-timepicker"
                    format="HH:mm"
                  />
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12>
                  <v-radio-group
                    v-model="selectedStoreType"
                    row
                    @change="selectStoreType()"
                  >
                    <v-radio
                      :value="0"
                      color="primary"
                      label="Select store"
                    ></v-radio>
                    <v-radio
                      :value="1"
                      color="primary"
                      label="Partner store"
                    ></v-radio>
                    <v-radio
                      :value="2"
                      color="primary"
                      label="No partner store"
                    ></v-radio>
                    <v-radio
                      :value="3"
                      color="primary"
                      label="All store"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>

                <v-flex class="pr-2" xs12>
                  <v-autocomplete
                    v-if="selectedStoreType == 0"
                    prepend-icon="store_mall_directory"
                    :items="storeList"
                    item-text="store_name_th"
                    item-value="store_id"
                    v-model="baseForm.dm_store"
                    :loading="isLoading"
                    chips
                    clearable
                    deletable-chips
                    label="กรุณาเลือกร้านค้าที่ร่วมแคมเปญ"
                    multiple
                    :rules="[rules.required]"
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
              <v-progress-linear
                v-show="isProgressbarLoading"
                :indeterminate="true"
              ></v-progress-linear>
              <v-layout row wrap text-xs-right>
                <v-flex xs12>
                  <v-btn
                    color="success"
                    large
                    text-xs-center
                    :loading="isSending"
                    @click="handleSubmit()"
                    >SAVE</v-btn
                  >
                  <v-btn
                    :loading="isSending"
                    color="red"
                    @click="disableDialog"
                    class="white--text"
                    large
                    >Cancel</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
export default {
  components: {
    VueTimepicker,
  },
  props: [
    "isToggleDialogCampaign",
    "baseForm",
    "editIndex",
    "storeList",
    "isLoading",
  ],
  watch: {
    isToggleDialogCampaign() {
      if (this.isToggleDialogCampaign == true) {
        this.$refs.form.resetValidation();
        this.selectedStoreType = 0;
        console.log(this.baseForm);
        if (
          this.baseForm.dm_store.length > 0 &&
          this.baseForm.dm_store[0] == 0
        ) {
          this.selectedStoreType = 3;
        }
      } else {
        this.selectedStoreType = 0;
      }
    },
  },
  data() {
    return {
      isSending: false,
      selectedStoreType: 0,
      isProgressbarLoading: false,
      newForm: {},
      datestart: new Date().toISOString().substr(0, 10),
      dateend: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      valid: true,
      titleFrms: "",
      rules: {
        max: (v) =>
          (v && v.length <= 10) || "Name must be less than 10 characters",
        required: (v) => !!v || typeof v == "number" || "กรุณากรอกข้อมูล",
      },
    };
  },
  computed: {
    setTitleFrms() {
      return this.finalEditIndex === 1 ? "Edit Campaign" : "Add Campaign";
    },
    finalEditIndex() {
      return this.editIndex;
    },
  },
  methods: {
    selectStoreType() {
      this.baseForm.dm_store = [];
    },
    disableDialog() {
      if (this.finalEditIndex === 1) {
        //status editing
        this.$emit("switchTitleStatusDialog");
      }
      this.$emit("resetFrm");
      this.$emit("disableDialog"); //เรียกใช้ฟังก์ชั่นผ่านของ addcampaign component ผ่าน event disableDialog
      this.$refs.form.resetValidation();
    },
    async handleSubmit(value) {
      if (this.$refs.form.validate()) {
        this.isSending = true;
        if (this.selectedStoreType == 3) {
          this.baseForm.dm_store = [0];
          // this.baseForm.dm_store = [];
          // for (let val of this.storeList) {
          //   this.baseForm.dm_store.push(val.store_id);
          // }
        } else if (this.selectedStoreType == 2) {
          this.baseForm.dm_store = [];
          for (let val of this.storeList) {
            if (val.store_partner == false) {
              this.baseForm.dm_store.push(val.store_id);
            }
          }
        } else if (this.selectedStoreType == 1) {
          this.baseForm.dm_store = [];
          for (let val of this.storeList) {
            if (val.store_partner == true) {
              this.baseForm.dm_store.push(val.store_id);
            }
          }
        }
        this.setNewFormFormat();
        this.snackbar = true;
        if (this.editIndex == 1) {
          //status editting
          this.isProgressbarLoading = true;
          await this.$emit("editCampaignMarketing", this.newForm); //edit campaign function
          this.isProgressbarLoading = false;
          this.$emit("switchTitleStatusDialog");
        } else {
          //status adding
          this.isProgressbarLoading = true;
          await this.$emit("addCampaignMarketing", this.newForm); //add campaign function
          this.isProgressbarLoading = false;
        }
        this.$refs.form.resetValidation();
        this.$emit("resetFrm");
        this.$emit("disableDialog");
        this.isSending = false;
      }
    },
    setNewFormFormat() {
      this.newForm = {
        ...this.baseForm,
        dm_time_start:
          this.baseForm.datestart +
          "T" +
          (this.baseForm.timestart.HH +
            ":" +
            this.baseForm.timestart.mm +
            ":" +
            "00"),
        dm_time_end:
          this.baseForm.dateend +
          "T" +
          (this.baseForm.timeend.HH +
            ":" +
            this.baseForm.timeend.mm +
            ":" +
            "00"),
      };
      delete this.newForm.timestart;
      delete this.newForm.timeend;
      delete this.newForm.datestart;
      delete this.newForm.dateend;
    },
  },
};
</script>

<style>
.custom-timepicker input[type="text"] {
  width: 100%;
}
.custom-timepicker.time-picker .display-time {
  margin-top: 18px;
  outline: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.42);
  border-top: none;
  border-left: none;
  border-right: none;
}
.custom-timepicker.time-picker .display-time:hover {
  border-bottom: 1px solid #222222;
}

.custom-timepicker.time-picker .display-time:focus {
  border-bottom: 1px solid #222222;
}
</style>
